import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import useConfigurationSummary from '../../hooks/use-configuration-summary.js';
import { ConfigurationSummary } from './ConfigurationSummary.js';

const ConfigurationSummaryContainer = ()=>{
    const isLandscape = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    const { frame , lensType , lensPackage , addOn , bundlePrice , hasVisitedStepAddOn , hasVisitedStepLensPackage , totalPricePrefix , minimumBundleSupplement ,  } = useConfigurationSummary({
        location: isLandscape ? 'desktop' : 'mobile'
    });
    return /*#__PURE__*/ React.createElement(ConfigurationSummary, {
        frame: frame,
        lensType: lensType,
        lensPackage: lensPackage,
        addOn: addOn,
        bundlePrice: bundlePrice,
        hasVisitedStepLensPackage: hasVisitedStepLensPackage,
        hasVisitedStepAddOn: hasVisitedStepAddOn,
        totalPricePrefix: totalPricePrefix,
        minimumBundleSupplement: minimumBundleSupplement
    });
};

export { ConfigurationSummaryContainer };
//# sourceMappingURL=ConfigurationSummaryContainer.js.map
